import bso from '../../assets/OtherEvents/bso.jpg';
import campus from '../../assets/OtherEvents/campus.webp';
import spadina from '../../assets/OtherEvents/koffler.jpg';

export const otherEventsData = [
  {
    title: 'Black Student Orientation',
    description:
      'Want to celebrate Black culture, embrace the community at the University of Toronto, and prepare yourself for the UofT experience? Black Student Orientation, organized by Black Students for Black students, is an opportunity to make a smooth transition into university life, make new friends, and start the year on a positive note! Registration for this FREE orientation is open!',
    image: bso,
    link: 'https://www.instagram.com/uoftbso/',
  },
  // {
  //   title: 'Faculty Orientation Events',
  //   description:
  //     "Check out the schedule for Faculty Orientation Events happening on August 28th!",
  //   image: campus,
  //   link: 'https://undergrad.engineering.utoronto.ca/event/faculty-orientation-events/',
  // },
  {
    title: 'Spadina Block Party',
    description:
      "Join us for the Multi-Faith Centre Spadina Block Party, a welcoming and inclusive event for all U of T students. Whether you're a first-year, a returning student, or just curious about what the Multi-Faith Centre offers, this event is a chance to meet new people, explore resources, and celebrate our diverse campus community. Connect with student life units and U of T divisions that support well-being, spirituality, and community building.",
    image: spadina,
    link: 'https://folio.utoronto.ca/students/events/detail/5645789',
  },
];
